export * from './label.component';
